import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'
import SelectPurchaseOrder from '../libs/SelectPurchaseOrder'
import PurchaseOrdersTableSkeletons from './skeletons/PurchaseOrdersTableSkeletons'
/**
 * The PurchaseOrdersLinesTable compoenent
 * @component
 *
 * @param {Object} props
 * @param {Array} props.purchaseOrdersLines
 * @param {boolean} props.loader
 * @param {function} props.reFetch
 * @returns {JSX.Element}
 */

const PurchaseOrdersLinesTable = ({ purchaseOrderLines, loader, reFetch }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: '50vh',
        width: '100%',
      }}
    >
      <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ px: 2, py: 1, width: 'auto', whiteSpace: 'nowrap' }} align="left">
              Seleccionada
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Nº Línea
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Nº Externo
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Nº Interno
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Código Artículo
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Descripción
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Presentación
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Unidades Pedidas
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Unidades Entregadas
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Precio Unidad
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Importe Total
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Cantidad Entregada
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Presentación Albarán
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Nº Línea Albarán
            </TableCell>
            <TableCell sx={{ px: 2, py: 1 }} align="right">
              Total Entregado
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{loader && <PurchaseOrdersTableSkeletons rows={5} columns={15} />}</TableBody>
        {!loader &&
          purchaseOrderLines?.map((row) => (
            <TableRow
              key={row?.id}
              hover
              tabIndex={-1}
              sx={{
                cursor: 'pointer',
                bgcolor: 'inherit',
              }}
            >
              <TableCell
                padding="checkbox"
                aling="right"
                sx={{ px: 2, py: 1, width: '1vh', whiteSpace: 'nowrap' }}
              >
                <Tooltip title={row.selected ? 'Deseleccionar linea' : 'Seleccionar linea'}>
                  <Checkbox
                    checked={row.selected}
                    inputProps={{ 'aria-label': 'select row' }}
                    onClick={() => {
                      SelectPurchaseOrder.toggleOrderLine(row.id).then(() => {
                        reFetch()
                      })
                    }}
                  />
                </Tooltip>
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.numero_linea}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.numero_doc_ext}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.numero_doc_interno}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.codigo_articulo}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.descripcion}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.presentacion}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.unidades_pedidas}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.unidades_entregadas}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.precio_presentacion}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.importe_lin_neto}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.cantidad_entregada}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.presentacion_albaran}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.numero_linea_albaran}
              </TableCell>
              <TableCell align="right" sx={{ px: 2, py: 1 }}>
                {row.total_entregado}
              </TableCell>
            </TableRow>
          ))}
      </Table>
    </TableContainer>
  )
}

export default PurchaseOrdersLinesTable
